import classNames from 'classnames'
import { PropsUl } from './types'
import './ul.css'

export default function Ul({ children, className }: PropsUl) {
    return <ul className={classNames('ul', className)}>{children}</ul>
}
